<template>
  <div
    class="gl-risk-info"
    :style="{ backgroundColor: getColorByRiskLevel(value) }"
  >
    <div
      v-if="levelFirstLetter"
      class="gl-risk-info__value"
    >
      {{ levelFirstLetter }}
    </div>
  </div>
</template>

<script>
// Utils
import { calculateRiskLevel, getColorByRiskLevel } from '@/utils/risk-formatter'

export default {
  name: 'GlRiskBadge',
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },
  },
  computed: {
    levelFirstLetter() {
      const level = calculateRiskLevel(this.value)
      if (!level) return ''
      return level.toString().trim().charAt(0)
    },
  },
  methods: {
    calculateRiskLevel,
    getColorByRiskLevel,
  },
}
</script>

<style>
.gl-risk-info {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  flex-shrink: 0;
}

.gl-risk-info__value {
  color: var(--Basic-A-900, #fff);
  text-align: center;
  font-size: var(--Size-XS, 10px);
  font-style: normal;
  font-weight: 600;
  line-height: 13px;
  text-transform: uppercase;
}
</style>
